define("Bazaarvoice.PDP.Questions.View", [
  "SCView",
  "bazaarvoice_pdp_questions.tpl",
  "underscore",
], function (SCViewComponent, bazaarvoice_pdp_questions_tpl, _) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function BazaarvoicePDPQuestionsView(options) {
    SCView.call(this);

    this.options = options || {};
    this.container = this.options.container;
    this.template = bazaarvoice_pdp_questions_tpl;
    this.pdp = this.container.getComponent("PDP");
    // For matrix selection
    this.pdp.cancelableOn("afterOptionSelection", _.bind(this.render, this));
  }

  BazaarvoicePDPQuestionsView.prototype = Object.create(SCView.prototype);

  BazaarvoicePDPQuestionsView.prototype.constructor =
    BazaarvoicePDPQuestionsView;

  BazaarvoicePDPQuestionsView.prototype.getItem = function () {
    var iteminfo = this.pdp && this.pdp.getItemInfo();

    if (!iteminfo) {
      return {};
    }

    var selectedMatrixChilds = this.pdp.getSelectedMatrixChilds();
    var matrixSelected =
      !!_.size(selectedMatrixChilds) && _.first(selectedMatrixChilds);

    return matrixSelected ? matrixSelected : iteminfo.item || {};
  };

  BazaarvoicePDPQuestionsView.prototype.getContext = function () {
    var item = this.getItem();

    return {
      productId: item.itemid,
    };
  };

  return BazaarvoicePDPQuestionsView;
});
